/* eslint-disable react/jsx-key */
import React, { useContext, useEffect, useState } from "react";
import Topbar from "../../../components/TopBarComponent/Topbar";
import TableBody from "../../../constants/dummyData.json";
import { Col, Container, Nav, Row, Tab, Tabs } from "react-bootstrap";
import Button from "../../../components/ButtonComponent/Button";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import DataTable from "../../../components/DataTableComponent/DataTable";
import DownloadICon from "../../../assets/images/Icons/pdfIcon.svg";
import VistorImage from "../../../assets/images/vistorImage.svg";
import HorizontalLine from "../../../assets/images/horizontalLine.svg";
import "./visitorsDetail.css";
import PdfImage from "../../../assets/images/Icons/pdfIcon.svg";
import { VisitorsDetailContext } from "../VisitorsDetailView";
import IconProfile from "../../../assets/images/Icons/profileIcon.svg";
import { baseURL } from "../../../api/Axios";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import IdPhotoPopup from "../../../components/IdOrPhotoPopUpComponent/IdphotoPopup";
const VisitorsDetail = ({ textContent }) => {
  const {
    visiblePdfButton,
    setVisiblePdfButton,
    goBack,
    vistorInfo,
    noEntryDetail,
    setNoEntryDetails,
    entryDetail,
    showAlert,
    dataEntry,
    setShowAlert,
    alertMessage,
    setAlertMessage,
    modalIDPhotoOpenStatus,
    setModalIDPhotoOpenStatus,
    logout,
    statusCode,
  } = useContext(VisitorsDetailContext);

  const Content = TableBody.visitorsDetails;

  const handleSelect = (key) => {
    key === "visitors-details"
      ? setVisiblePdfButton(false)
      : setVisiblePdfButton(true);
  };

  const tableHeader = [
    // { title: "No", prop: "Number", isSortable: true },
    { title: "Zone", prop: "Zone" },
    { title: "In/Out", prop: "in_out" },
    { title: "Date", prop: "date" },
    { title: "Time", prop: "time" },
  ];
  const profileDetailVistors = [
    {
      vistorName: vistorInfo?.VisitorName,
      type: vistorInfo?.VisitorType,
      vechileNo: vistorInfo?.VehicleNo,
      magneticCardID: vistorInfo?.MagneticId,
      contactNo: vistorInfo?.VisitorPhoneNo,
      coPassengersList: vistorInfo?.CoPassengerFileName,
      emergencyContactNo: vistorInfo?.EmergencyNo,
      location: vistorInfo?.LocationOfVisit,
      Company: vistorInfo?.VisitorCompany,
      fromplace: vistorInfo?.VisitorLocation,
      Category: vistorInfo?.CategoryFName,
      vistorType: vistorInfo?.Type,
      idProof: vistorInfo?.idProof,
      vistorImage: vistorInfo?.ImagePath,
    },
  ];
  const idprof = vistorInfo?.idProof;
  const idProof = idprof && "Id" + idprof?.match(/.{1,28}(?:\s|$)/g);
  const str = vistorInfo?.CoPassengerFileName;
  const coPassengerFileList = "list" + str?.match(/.{1,28}(?:\s|$)/g);

  const imgPath = vistorInfo?.ImagePath
    ? `${baseURL}/images/${vistorInfo?.ImagePath} `
    : IconProfile;

  return (
    <div className="visitors-detail">
      <Topbar />
      <Container>
        <div className="heading-row my-3">
          <div className="title-box">
            <img
              className="back-arrow"
              src={BackArrow}
              alt="Back Arrow"
              width={17}
              onClick={() => goBack()}
            />
            <p className="title-name visitorname">{vistorInfo?.VisitorName}</p>
          </div>
        </div>

        <Tabs
          onSelect={handleSelect}
          defaultActiveKey="visitors-details"
          id="uncontrolled-tab-example"
        >
          <Tab eventKey="visitors-details" title="VISITORS DETAILS">
            <div className="profile-details">
              {profileDetailVistors.map((profileList) => {
                return (
                  <div>
                    <Row>
                      <Col md={2}>
                        <div className="profileImgVistorDiv">
                          {vistorInfo.ImagePath !== "" ||
                          vistorInfo.ImagePath !== null ? (
                            <img
                              className="detailVistorDiv"
                              src={imgPath}
                              alt="vistor Image"
                            />
                          ) : (
                            <img
                              className="profileVistorDiv"
                              src={IconProfile}
                              alt="Vistor Image"
                            />
                          )}
                        </div>
                      </Col>
                      <Col md={5} className="profileDetailDiv">
                        <Row>
                          <Col md={12}>
                            <Row>
                              <Col md={4}>
                                <label className="vistoraLabel">
                                  {textContent.vistorName}
                                </label>
                              </Col>
                              <Col md={8}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.vistorName}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} width={40} />
                          <Col md={12}>
                            <Row>
                              <Col md={4}>
                                <label className="vistoraLabel">
                                  {textContent.type}
                                </label>
                              </Col>
                              <Col md={8}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.type}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} width={40} />
                          <Col md={12}>
                            <Row>
                              <Col md={4}>
                                <label className="vistoraLabel">
                                  {textContent.vechileNo}
                                </label>
                              </Col>
                              <Col md={8}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.vechileNo}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} />
                          <Col md={12}>
                            <Row>
                              <Col md={4}>
                                <label className="vistoraLabel">
                                  {textContent.magneticCardID}
                                </label>
                              </Col>
                              <Col md={8}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.magneticCardID}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} />
                          <Col md={12}>
                            <Row>
                              <Col md={4}>
                                <label className="vistoraLabel">
                                  {textContent.contactNo}
                                </label>
                              </Col>
                              <Col md={8}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.contactNo}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} />
                          {profileList.vistorType == "I" ? (
                            <Col md={12}>
                              <Row>
                                <Col md={4}>
                                  <label className="vistoraLabel">
                                    {textContent.idProof}
                                  </label>
                                </Col>
                                <Col md={8}>
                                  <label className="vistorSemicolon">:</label>
                                  <label className="vistoraLabel idproof-name">
                                    <div
                                      className="poupId"
                                      onClick={() =>
                                        setModalIDPhotoOpenStatus(true)
                                      }
                                    >
                                      {profileList.idProof}
                                    </div>
                                  </label>
                                </Col>
                              </Row>
                            </Col>
                          ) : (
                            <Row>
                              <Col md={4}>
                                <label className="vistoraLabel">
                                  {textContent.idProof}
                                </label>
                              </Col>
                              <Col md={8} className="poupId">
                                <label className="vistorSemicolon">:</label>
                                <label
                                  className="vistoraLabel"
                                  onClick={() => {
                                    setModalIDPhotoOpenStatus(true);
                                  }}
                                >
                                  {idProof}
                                </label>
                              </Col>
                            </Row>
                          )}
                        </Row>
                      </Col>
                      <Col md={5} className="profileDetailDiv">
                        <Row>
                          <Col md={12}>
                            <Row>
                              <Col md={5}>
                                <label className="vistoraLabel">
                                  {textContent.emergencyContactNo}
                                </label>
                              </Col>
                              <Col md={7}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.emergencyContactNo}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} width={30} />
                          <Col md={12}>
                            <Row>
                              <Col md={5}>
                                <label className="vistoraLabel">
                                  {textContent.location}
                                </label>
                              </Col>
                              <Col md={7}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.location}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} width={40} />
                          <Col md={12}>
                            <Row>
                              <Col md={5}>
                                <label className="vistoraLabel">
                                  {textContent.Company}
                                </label>
                              </Col>
                              <Col md={7}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.Company}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} />
                          <Col md={12}>
                            <Row>
                              <Col md={5}>
                                <label className="vistoraLabel">
                                  {textContent.fromplace}
                                </label>
                              </Col>
                              <Col md={7}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.fromplace}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} />
                          <Col md={12}>
                            <Row>
                              <Col md={5}>
                                <label className="vistoraLabel">
                                  {textContent.Category}
                                </label>
                              </Col>
                              <Col md={7}>
                                <label className="vistorSemicolon">:</label>
                                <label className="vistoraLabel">
                                  {profileList.Category}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                          <img src={HorizontalLine} />
                          {profileList.vistorType == "G" ? (
                            <Col md={12}>
                              <Row>
                                <Col md={5}>
                                  <label className="vistoraLabel">
                                    {textContent.coPassengersList}
                                  </label>
                                </Col>
                                <Col md={7}>
                                  <label className="vistorSemicolon">:</label>

                                  <label className="vistoraLabel">
                                    {/* <img src={PdfImage} /> */}
                                    {coPassengerFileList}
                                  </label>
                                </Col>
                              </Row>
                            </Col>
                          ) : (
                            ""
                            // <img src={PdfImage} />
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </div>
          </Tab>

          <Tab eventKey="entry-details" title="MOVEMENTS">
            {entryDetail ? (
              <div>
                {/* <div className="position-relative">
                  <span className="download-text">
                    <a
                      className="excel-download"
                      href={`${baseURL}/excel/${dataEntry?.excelFile}`}
                    >
                      {textContent.downLoadText}
                      <img src={ExcelIcon} alt="Excel-icon" />
                    </a>
                  </span>
                </div> */}

                <DataTable
                  tableData={entryDetail}
                  header={tableHeader}
                  isPagination={true}
                />
              </div>
            ) : (
              <div className="no-item">No entry data found.</div>
            )}
          </Tab>
        </Tabs>
      </Container>

      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => setShowAlert(false)
        }
      />
      <IdPhotoPopup
        show={modalIDPhotoOpenStatus}
        setShow={setModalIDPhotoOpenStatus}
        idproof={vistorInfo?.idProof}
      />
    </div>
  );
};

export default VisitorsDetail;
